import type React from "react";
import { useState } from "react";
import { OnOffSwitch } from "@similarweb/ui-components";

type OnOffSwitchContainerProps = {
    isSelected: boolean;
    onToggle: (isSelected: boolean) => void;
    isDisabled?: boolean;
};

const OnOffSwitchContainer: React.FC<OnOffSwitchContainerProps> = ({
    isSelected: initialSelected,
    onToggle,
    isDisabled,
}) => {
    const [isSelected, setIsSelected] = useState(initialSelected);

    const onItemClick = () => {
        const newSelection = !isSelected;
        setIsSelected(newSelection);
        onToggle(newSelection);
    };

    return (
        <OnOffSwitch
            isSelected={isSelected}
            onClick={onItemClick}
            isDisabled={isDisabled}
        />
    );
};

export default OnOffSwitchContainer;
